import { defineComponent as n, createBlock as r, openBlock as o, unref as d, mergeProps as c, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconReassuranceCreditCardOutlined",
  __name: "IconReassuranceCreditCardOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (p, e) => (o(), r(d(m), c(t, { "view-box": "0 0 48 48" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", { d: "M17.09 34.87h.09a.49.49 0 0 0 .51-.4l.47-2.49a.508.508 0 0 0-1-.18l-.47 2.48a.5.5 0 0 0 .4.59m-2.86-.61h-.09a.49.49 0 0 1-.4-.58l1.31-7a.51.51 0 0 1 .58-.4.5.5 0 0 1 .4.59l-1.31 7a.51.51 0 0 1-.49.39m14.829-16.04c.414.233.342 1.143-.16 2.033-.502.89-1.244 1.422-1.658 1.19-.413-.234-.342-1.145.16-2.035.502-.89 1.244-1.422 1.658-1.189m-3.766.947c.869-1.272 1.03-2.675.36-3.133-.67-.458-1.919.202-2.788 1.475-.87 1.272-1.03 2.675-.36 3.133.67.458 1.918-.202 2.788-1.475m.647 7.094a9 9 0 0 0 3.28 0 .2.2 0 0 0 .14-.2.19.19 0 0 0-.18-.21 15.156 15.156 0 0 1-3-.61A12.41 12.41 0 0 1 23.46 24a11.168 11.168 0 0 1-2.29-1.87 21.715 21.715 0 0 1-2-2.36.25.25 0 0 0-.27-.09.25.25 0 0 0-.16.32 8.81 8.81 0 0 0 4.08 5.11 9.328 9.328 0 0 0 3.12 1.15" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M29.06 41.62a4.768 4.768 0 0 0 .84.07v-.02A4.51 4.51 0 0 0 34.31 38l4.37-23.42a4.5 4.5 0 0 0-3.6-5.25L19 6.33a4.5 4.5 0 0 0-5.24 3.6L9.4 33.36a4.52 4.52 0 0 0 3.6 5.25l16.06 3.01M15.95 8.066a3.49 3.49 0 0 1 2.88-.746l16.08 3a3.419 3.419 0 0 1 2.24 1.47 3.48 3.48 0 0 1 .56 2.62l-4.38 23.42a3.51 3.51 0 0 1-4.09 2.8l-16.08-3a3.51 3.51 0 0 1-2.79-4.09l4.38-23.43a3.49 3.49 0 0 1 1.2-2.044",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
